import React, { useContext } from 'react';

import './About.css';
import { ThemeContext } from '../../contexts/ThemeContext';
import { aboutData } from '../../data/aboutData'



function About() {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="about" id="about" style={{backgroundColor: theme.secondary}}>
            <div className="line-styling">
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-circle" style={{backgroundColor: theme.primary}}></div>
              <div className="style-line" style={{backgroundColor: theme.primary}}></div>
            </div>
            <div className="about-body">
                <div className="about-description">
                    <h2 style={{color: theme.primary}}>{aboutData.title}</h2>
                    {/* <p style={{color:theme.tertiary80}}>{aboutData.description1}<br/><br/>{aboutData.description2}</p> */}
                    <p style={{color:theme.tertiary80}}>
                        I’m Algert, a Düsseldorf,Germany based Full Stack Developer with more than a decade of experience building scalable back-end systems, intuitive front-end interfaces, and custom WordPress/Elementor solutions.
                   
<br/><br/>
<strong>Backend Development</strong><br/>                        
I have more than 10 years of experience in back-end development, with a strong focus on PHP (Laravel and Symfony). I’ve built scalable applications, APIs, and enterprise solutions from scratch, always prioritizing clean architecture, performance, and security. My experience also includes .NET (C#, VB.NET) and database design with SQL Server, MySQL, and MariaDB, giving me the ability to work across different technology stacks and environments.
<br/><br/>
<strong>Frontend Development</strong><br/>
On the front end, I have worked extensively with Angular, TypeScript, ReactJS, JavaScript, jQuery, and Bootstrap to deliver responsive, modern, and user-friendly interfaces. I emphasize pixel-perfect implementation when converting designs into code, ensuring layouts and interactions are precise, consistent, and optimized for all devices.
<br/><br/>
<strong>WordPress & Elementor</strong><br/>
In recent years, I’ve specialized in WordPress development, particularly using Elementor. I regularly translate Figma designs into fully functional, responsive websites, with a strong focus on pixel-perfect accuracy and smooth user experience. I combine design fidelity with performance optimization to deliver sites that are both visually impressive and technically reliable.
<br/><br/>
<strong>Custom Plugins & Themes</strong><br/>
Beyond design-driven work, I create custom plugins and themes for WordPress to meet unique business requirements. This includes adding functionality that off-the-shelf solutions don’t provide, integrating with third-party APIs, and extending WordPress to support specialized workflows. These tailored solutions help clients scale their digital platforms while maintaining flexibility and performance.
                    </p>
                </div>
                <div className="about-img">
                    <img 
                        src={aboutData.image === 1 ? theme.aboutimg1 : theme.aboutimg2}  
                        alt="" 
                    />
                </div>
            </div>
        </div>

    )
}

export default About
